import type { HealthOverviewParameter } from '@/domain/health';

/** Visual severity for Varsler cards (matches Figma: high / medium / low). */
export type HealthAlertDisplayLevel = 'high' | 'medium' | 'low';

/** Dashboard cards show alert metrics as a `pill`; the detail information panel `inline`. */
export type HealthAlertBadgeVariant = 'pill' | 'inline';

export function isHealthAlertParameter(parameter: Pick<HealthOverviewParameter, 'alert'>): boolean {
    return parameter.alert.level !== 'stable';
}

const LOW_INDEX_THRESHOLD_RATIO = 0.75;

/**
 * Maps API `alert.level` to dashboard display tier.
 * `increasing` below ~75% of the applied threshold is shown as low (yellow).
 */
export function getHealthAlertDisplayLevel(
    parameter: Pick<HealthOverviewParameter, 'alert' | 'daily'>
): HealthAlertDisplayLevel {
    const { alert, daily } = parameter;

    if (alert.level === 'high') {
        return 'high';
    }

    if (alert.level !== 'increasing') {
        return 'low';
    }

    const index = daily?.index ?? null;
    const threshold = alert.appliedThreshold;

    if (threshold != null && index != null && index < threshold * LOW_INDEX_THRESHOLD_RATIO) {
        return 'low';
    }

    return 'medium';
}

export { compareHealthAlertParameters } from './healthParameterMetricDisplay';
